import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageDotsFilledIcon } from '@getgo/chameleon-icons/react';
import { Badge } from '@material-ui/core';
import classNames from 'classnames';
import { webChatIcons } from "../helpers";
import RoundButton from "../RoundButton";
import { useEffect, useState } from 'react';
import { WebChatIconType } from "../../state/webChat/types";
import classes from './index.module.scss';
const ChatBubble = ({ color, unread, alignLeft = false, chatIcon, greetingText, greetingDelay, onClick, onGreet, }) => {
    const [showGreeting, setShowGreeting] = useState(false);
    useEffect(() => {
        setShowGreeting(false);
        if (greetingText) {
            if (greetingDelay > 0) {
                setTimeout(() => {
                    onGreet === null || onGreet === void 0 ? void 0 : onGreet();
                    setShowGreeting(true);
                }, greetingDelay);
            }
            else {
                onGreet === null || onGreet === void 0 ? void 0 : onGreet();
                setShowGreeting(true);
            }
        }
    }, [greetingText, greetingDelay]);
    const renderChatIcon = () => {
        switch (chatIcon.type) {
            case WebChatIconType.GENERIC:
                return chatIcon.genericIconName && webChatIcons[chatIcon.genericIconName] ? (webChatIcons[chatIcon.genericIconName]()) : (_jsx(MessageDotsFilledIcon, {}, void 0));
            case WebChatIconType.CUSTOM:
                return _jsx("img", { className: classes.customIcon, src: chatIcon.customIconCBoxUrl }, void 0);
        }
    };
    return (_jsxs("section", Object.assign({ className: classNames(classes.bubble, {
            [classes.alignLeft]: alignLeft,
            [classes.alignRight]: !alignLeft,
        }) }, { children: [showGreeting && (_jsxs("div", Object.assign({ className: classes.greeting }, { children: [_jsx("span", { children: greetingText }, void 0), _jsx("svg", Object.assign({ viewBox: "0 0 8 8" }, { children: _jsx("path", { d: "M 8 0 L 8 6 C 8 6 8 9 5 6 L 0 0.5" }, void 0) }), void 0)] }), void 0)), _jsx(RoundButton, Object.assign({ className: classes.button, color: color, variant: "primary", size: "xxlarge", onClick: onClick }, { children: _jsx(Badge, Object.assign({ color: "error", classes: {
                        colorError: classes.error,
                    }, className: classes.badge, invisible: !unread, badgeContent: unread, anchorOrigin: { horizontal: 'left', vertical: 'top' } }, { children: renderChatIcon() }), void 0) }), void 0)] }), void 0));
};
export default ChatBubble;
//# sourceMappingURL=index.js.map